import { setRemoteDefinitions } from '@spins-delivery-platform/load-remote-module';
import { environment } from './environments/environment';
import { logger } from './logging';

import('./bootstrap');

const definitions = {
  child: environment.remoteBrandInsightsUrl,
  'bi-powertabs': environment.remotePowerTabsUrl,
  'brand-insights-ui': environment.remoteBrandInsightsUrl,
  'ignite-plus-ui': environment.remoteIgnitePlusUrl,
  'partner-insights-ui': environment.remotePartnerInsightsUrl,
  'product-hub-ui': environment.remoteProductHubUrl,
  'retail-insights-ui': environment.remoteRetailInsightsUrl,
  'foundry': environment.remoteFoundry,
  'try-foundry': environment.remoteTryFoundry,
  'insights-builder': environment.remoteInsightsBuilder,
  'extracts': environment.remoteExtractsUrl,
  'traderoi-ui': environment.remoteTraderoiUrl,
  'key-account-approvals': environment.remoteKeyAccountApprovalsUrl
};

setRemoteDefinitions(definitions);
import('./bootstrap').catch((err) => logger.error(err));
